import React from "react";
import styles from "./index.module.scss";

const ChartSkeletonLoader = ({ type = "line" }) => {
	// Generate bars/lines for the chart
	const generateBars = () => {
		const bars = [];
		for (let i = 0; i < 8; i++) {
			// Calculate height based on chart type
			const height =
				type === "line" ? Math.sin(i * 0.8) * 40 + 50 : Math.random() * 50 + 30;

			bars.push(
				<div
					key={i}
					className={`${styles.bar} ${styles.pulse}`}
					style={{ height: `${height}%` }}
				/>,
			);
		}
		return bars;
	};

	// Generate x-axis labels
	const generateLabels = () => {
		const labels = [];
		for (let i = 0; i < 4; i++) {
			labels.push(
				<div key={i} className={`${styles.label} ${styles.pulse}`} />,
			);
		}
		return labels;
	};

	return (
		<div className={styles.container}>
			{/* Loading text overlay */}
			<div className={styles.loadingTextContainer}>
				<span className={styles.loadingText}>圖表載入中...</span>
			</div>

			{/* Chart skeleton */}
			<div className={styles.chartArea}>{generateBars()}</div>

			{/* X-axis */}
			<div className={styles.xAxis} />

			{/* Labels placeholder */}
			<div className={styles.labelContainer}>{generateLabels()}</div>
		</div>
	);
};

export default ChartSkeletonLoader;
